import officialIcon from '@/assets/official_icon.svg';
import officialText from '@/assets/official_text.svg';
const OfficialTag = ({ className = '' }) => {
  return (
    <div className={`inline-flex items-center gap-[2px] h-[18px] px-[4.5px] rounded-[3px] whitespace-nowrap gradient-art-bg ${className}`}>
      <img src={officialIcon} alt="Official" className="block w-[11.25px] h-[11.25px]" />
      <img src={officialText} alt="Official" className="block w-[45px] h-[16px]" />
    </div>
  );
};

export default OfficialTag;


